import { cn } from '@utils/index';
import React from 'react';

interface EmptyStateProps {
  title: string;
  description?: string;
  icon?: React.ComponentType<{ className?: string }>;
  className?: string;
}

/**
 * Shared centered empty-state for the Workforce Console. Used for four
 * distinct cases:
 *   1. No teams selected — prompt the user to pick one
 *   2. Selected teams aren't linked to any program in this org
 *   3. Selected teams span more programs than the console fetches at once
 *   4. Cases query returned nothing for the current filters
 */
export function EmptyState({ title, description, icon: Icon, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        'h-full flex flex-col items-center justify-center text-center px-6 py-12',
        className,
      )}
    >
      {Icon && <Icon className="size-8 text-muted-foreground mb-3" />}
      <div className="text-sm font-medium text-foreground">{title}</div>
      {description && (
        <div className="mt-1 text-xs text-muted-foreground max-w-sm">{description}</div>
      )}
    </div>
  );
}
